import React, { useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Input, UiButton } from '@shared/ui';
import { CustomModal } from '@shared/ui/CustomModal/CustomModal';

import cls from './ModalFiles.module.css';
import { useModalFiles } from './useModalFiles';

interface IEditProps {
    onHideModal: () => void;
    isShow: boolean;
}

export const Edit = ({ onHideModal, isShow }: IEditProps) => {
    const { t } = useTranslation();
    const { onRenameFile, currentName } = useModalFiles(onHideModal);
    const submitButtonRef = useRef(null);
    const inputRef = useRef<HTMLInputElement>(null);

    const [inputValue, setInputValue] = useState(currentName);
    const [inputError, setInputError] = useState({ isError: false, text: '' });

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onHideModal();
            }
            // if (event.key === 'Enter') {
            //     onRenameFile(inputValue);
            // }
        };
        if (isShow) {
            document.addEventListener('keydown', handleKeyDown);
        }
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isShow, onHideModal, inputValue, onRenameFile]);

    useEffect(() => {
        if (isShow) {
            submitButtonRef.current.focus();
            inputRef.current?.focus();
        }
    }, [isShow]);

    const handleSubmitForm = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (inputValue.trim().length === 0) {
            setInputError({ isError: true, text: t('Files.FileModal.InputError.text') });
            return;
        }
        if (inputValue.trim().length > 255) {
            setInputError({
                isError: true,
                text: t('Files.FileModal.InputError.maxLength.text'),
            });
            return;
        }
        onRenameFile(inputValue);
    };

    const handleInput = (name: string, value: string) => {
        setInputValue(value);
        setInputError({ isError: false, text: '' });
    };
    return (
        <>
            <CustomModal.Header>{t('Edit.return.ModalHeader')}</CustomModal.Header>
            <CustomModal.Body width="476px" classes={cls.textAlignCenter}>
                <form onSubmit={handleSubmitForm} id="file-modal">
                    {/* <input */}
                    {/*    onInput={handleInput} */}
                    {/*    value={inputValue} */}
                    {/*    className={cls.input} */}
                    {/*    ref={inputRef} */}
                    {/* /> */}
                    <Input
                        classes={['']}
                        value={inputValue}
                        error={inputError.text}
                        innerRef={inputRef}
                        onValueChange={handleInput}
                        inputClassName={cls.input}
                        errorClassName={cls.inputError}
                        name="folderInput"
                    />
                </form>
            </CustomModal.Body>
            <CustomModal.Footer>
                <UiButton
                    btnText={t('Edit.return.ModalFooter.cancelButton')}
                    btnColor="ghost"
                    className={cls.editModalBtn}
                    onClick={onHideModal}
                />
                <UiButton
                    btnColor="primary"
                    btnText={t('Edit.return.ModalFooter.saveButton')}
                    className={cls.editModalBtn}
                    // onClick={() => onRenameFile(inputValue)}
                    innerRef={submitButtonRef}
                    type="submit"
                    form="file-modal"
                />
            </CustomModal.Footer>
        </>
    );
};
